const responsiveIFrameContainer = {
  width: "100%",
  position: "relative",
  paddingBottom: "56.25%",
  paddingTop: 0,
  height: 0,
  overflow: "hidden",
};

const responsiveIFramePlayer = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
};

/**
 * Displays Genially interactive content by loading it via iFrame.
 * @param {string} url - e.g. "https://view.genial.ly/661d218329305800155314ec"
 * @param {string} title - e.g. "My Quiz"
 * @returns {Element}
 * @constructor
 */
const GeniallyIframe = ({ url, title = "" }) => {
  return (
    <div style={responsiveIFrameContainer}>
      <iframe
        title={title}
        frameBorder="0"
        width="100%"
        height="100%"
        style={responsiveIFramePlayer}
        src={url}
        type="text/html"
        allowFullScreen={true}
        scrolling="no"
        loading="lazy" // Lazy load when not visible
      />
    </div>
  );
};

export default GeniallyIframe;
